import CustomPersonReport from './custom-person-report.vue'
export default CustomPersonReport
